export default function getCountries<T extends { countries: unknown }>(state: T) {
    return { countries: state.countries };
}
